import qs from 'query-string';
import api from '../common/utils/api';

export const getUser = (_, { provider, projectId }) =>
  api({
    method: 'GET',
    path: `project/${projectId}/integrations/${provider}/user`
  });

export const getPublishTargets = (payload, { provider, projectId }) =>
  api({
    method: 'GET',
    path: `project/${projectId}/integrations/${provider}/publishTargets?${qs.stringify(payload)}`
  });

export const createPublishTarget = (payload, { provider, projectId }) =>
  api({
    method: 'POST',
    path: `project/${projectId}/integrations/${provider}/publishTargets?${qs.stringify(payload)}`
  });
